export enum PaymentAccountType {
  BankTransfer = 1,
  IBAN = 2,
  Instapay = 3,
  Satispay = 4,
  CreditCard = 5,
  PayPal = 6,
  Stripe = 7,
  Cash = 8,
  Other = 9,
}

export interface PaymentAccountTournamentLink {
  tournamentId: string;
  tournamentName: string;
  isActive: boolean;
  displayOrder: number;
}

export interface PaymentAccountDTO {
  id: string;
  accountName: string;
  accountType: PaymentAccountType;
  paymentAddress?: string;
  accountNumber?: string;
  iban?: string;
  bankName?: string;
  currency?: string;
  bic?: string;
  routingNumber?: string;
  paymentUrl?: string;
  additionalInfo?: string;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  tournaments: PaymentAccountTournamentLink[];
}

export interface TournamentPaymentAccountDTO {
  id: string;
  accountName: string;
  accountType: PaymentAccountType;
  paymentAddress?: string;
  accountNumber?: string;
  iban?: string;
  bankName?: string;
  currency?: string;
  bic?: string;
  routingNumber?: string;
  paymentUrl?: string;
  additionalInfo?: string;
  isActive: boolean;
  displayOrder: number;
}

export interface PaymentAccountSummaryDTO {
  id: string;
  accountName: string;
  accountType: PaymentAccountType;
  paymentAddress?: string;
  currency?: string;
  isActive: boolean;
  displayOrder: number;
}

export interface CreatePaymentAccountDTO {
  accountName: string;
  accountType: PaymentAccountType;
  paymentAddress?: string;
  accountNumber?: string;
  iban?: string;
  bankName?: string;
  currency?: string;
  bic?: string;
  routingNumber?: string;
  paymentUrl?: string;
  additionalInfo?: string;
  isActive?: boolean;
  displayOrder?: number;
}

export interface UpdatePaymentAccountDTO {
  accountName: string;
  accountType: PaymentAccountType;
  paymentAddress?: string;
  accountNumber?: string;
  iban?: string;
  bankName?: string;
  currency?: string;
  bic?: string;
  routingNumber?: string;
  paymentUrl?: string;
  additionalInfo?: string;
  isActive: boolean;
  displayOrder: number;
}

export interface LinkPaymentAccountDTO {
  paymentAccountId: string;
  isActive: boolean;
  displayOrder: number;
}

export const PaymentAccountTypeLabels: Record<PaymentAccountType, string> = {
  [PaymentAccountType.BankTransfer]: "Bank Transfer",
  [PaymentAccountType.IBAN]: "IBAN",
  [PaymentAccountType.Instapay]: "Instapay",
  [PaymentAccountType.Satispay]: "Satispay",
  [PaymentAccountType.CreditCard]: "Credit Card",
  [PaymentAccountType.PayPal]: "PayPal",
  [PaymentAccountType.Stripe]: "Stripe",
  [PaymentAccountType.Cash]: "Cash",
  [PaymentAccountType.Other]: "Other",
};
